// extracted by mini-css-extract-plugin
export var lightMode = "_1r-0";